import type { AxiosResponse, RequestOptions } from '@@/plugin-request/request';
import { RequestConfig, history } from '@umijs/max';
import { message } from 'antd';

interface ResponseStructure {
  success?: boolean;
  code: number;
  msg: string;
  data: any;
}

export const errorConfig: RequestConfig = {
  errorConfig: {
    errorThrower: (res: ResponseStructure) => {
      const error = new Error(res.msg);
      error.name = 'BizError';
      throw error;
    },

    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      if (error.name === 'BizError') {
        message.error(error.message);
      } else if (error.response) {
        message.error(`服务繁忙，请稍后再试，${error.response.status}`);
      } else if (error.request) {
        message.error('服务繁忙，请稍后再试');
      } else {
        message.error(error.name);
      }
    },
  },

  requestInterceptors: [
    (config: RequestOptions) => {
      config.headers = {
        ...config.headers,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      };
      const access_token = localStorage.getItem('access_token');
      if (access_token) {
        config.headers['Authorization'] = `Bearer ${access_token}`
      }
      return config
    },
  ],

  responseInterceptors: [
    (response: AxiosResponse) => {
      const { code, data } = response.data;
      if (code === 0) {
        response.data = data
      } else if (code == 401) {
        localStorage.removeItem('access_token');
        history.push('/user/login');
      } else if (data !== null) {
        // pass
      } else {
        response.data.success = false;
      }
      return response;
    }
  ],
};
